import { Tooltip } from "antd";
import _ from "lodash";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import NoAccessButtonWrapper from "@/Components/common/client/UserRoleAccess/NoAccessButtonWrapper";
import { ACTION_BTN_HOVER_CLR } from "@/Constants/common";
import { routingConstants } from "@/Constants/routingConstants";
import {
  deSelectAllCandidate,
  fetchInvitedCandidates,
  setInvitedCandidatesLoading,
  updatePagination,
  deleteInvitedCandidatedata,
  updateCandidateStatus,
} from "@/reducers/client_candidates/candidatesinvited";
import { fetchCandidateTypes } from "@/reducers/clientdashboard";
import { TOOLTIPTEXT, toastMessageText } from "@/utilities/CommonText";
import { apiEncrypt } from "@/utilities/keyEncryption";
import { showCommonToast } from "@/utilities/utils";

import ActionIcons from "../../../ActionIcons";

/**
 * This function is a React component that defines various actions such as sending multiple invitations, shortlisting candidates, and marking candidates as unsuitable. It also contains helper functions to extract registered and unregistered candidate data. The function returns JSX elements representing action buttons.
 *
 * @return {JSX.Element} JSX elements representing action buttons
 */
export const Actions = () => {
  const dispatch = useDispatch();
  const {
    selectedCandidate,
    invitedCandidates,
    filters,
    pagination,
    isSelectedAll,
    selectedIndex,
    selectedCandidateIds,
  } = useSelector((state) => state.clientCandidatesInvited);
  const { isPremiumAccount, clientUserAllPermissions } = useSelector(
    (state) => state.session,
  );
  const { user } = useSelector((state) => state.clientProfile);
  const [shortListLoading, setShortListLoading] = useState(false);
  const [unsuitableLoading, setUnsuitableLoading] = useState(false);
  const [removeStatusLoading, setRemoveStatusLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const [inviteLoading, setInviteLoading] = useState(false);
  const [autoApproveBankCandidateLoading, setAutoApproveBankCandidateLoading] =
    useState(false);
  const [
    RemoveautoApproveBankCandidateLoading,
    setRemoveAutoApproveBankCandidateLoading,
  ] = useState(false);

  /**
   * This function handles the reloading of the table.
   */
  const handleReloadTable = (
    unsuitable,
    sortlisted,
    isSelectedAll,
    ignoreIds,
    ids,
  ) => {
    dispatch(
      updateCandidateStatus({
        unsuitable,
        sortlisted,
        isSelectedAll,
        ignoreIds,
        ids,
      }),
    );
    dispatch(deSelectAllCandidate());
    // dispatch(
    //   updatePagination({
    //     ...pagination,
    //     currentPage: 1,
    //     isLastPage: false,
    //   }),
    // );
    // // dispatch(setInvitedCandidatesLoading(true));
    // dispatch(fetchInvitedCandidates(filters));
  };

  const refreshTable = () => {
    dispatch(
      updatePagination({
        ...pagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(fetchCandidateTypes());
    dispatch(setInvitedCandidatesLoading(true));
    dispatch(fetchInvitedCandidates(filters));
  };

  const handleDeleteConfirm = () => {
    dispatch(
      deleteInvitedCandidatedata({
        invitation_ids: selectedCandidateIds.join(","),
        callback: () => refreshTable(),
        loading: deleteLoading,
        setLoading: setDeleteLoading,
        isSelectedAll: isSelectedAll,
        ignoreIds: isSelectedAll
          ? invitedCandidates
              .filter((ele) => !selectedIndex.includes(ele.index))
              .map((ele) => ele.candidate_id)
              .join(",")
          : "",
      }),
    );
  };

  /**
   * Get the registered candidate IDs based on the selected candidates and their registration status.
   *
   * @return {string} Comma-separated list of candidate IDs
   */
  const getRegisteredCandidate = () => {
    let selectedIDs = [];
    let hasUnregistered = false;
    invitedCandidates.map((item) => {
      // console.log(item.candidate_email, _.includes(selectedCandidate, item.candidate_email),item.is_registered)
      if (
        _.includes(selectedCandidate, item.candidate_email) &&
        item.candidate_id !== "-" &&
        item.is_registered == 1
      ) {
        selectedIDs.push(item.candidate_id);
      }
      if (
        _.includes(selectedCandidate, item.candidate_email) &&
        item.candidate_id == "-" &&
        item.is_registered == 0
      ) {
        hasUnregistered = true;
      }
    });
    // if (hasUnregistered) {
    //   showCommonToast(toastMessageText.onlyRegisteredShortlistnandUnsuitable, {
    //     id: "no-candidate-selected",
    //   });
    // }
    return selectedIDs.join(",");
  };

  const getSelectedCandidateIds = () => {
    let selectedCandidateIds = [];
    let hasUnregisteredCandidate = false;

    invitedCandidates.forEach((candidate) => {
      if (
        selectedCandidate.includes(candidate.candidate_email) &&
        candidate.candidate_id !== "-" &&
        candidate.is_registered === 1
      ) {
        selectedCandidateIds.push(candidate.candidate_invitation_id);
      } else if (
        selectedCandidate.includes(candidate.candidate_email) &&
        candidate.candidate_id === "-" &&
        candidate.is_registered === 0
      ) {
        hasUnregisteredCandidate = true;
      }
    });

    // if (hasUnregisteredCandidate) {
    //   showCommonToast(toastMessageText.onlyRegisteredShortlistnandUnsuitable, {
    //     id: "no-candidate-selected",
    //   });
    // }

    return selectedCandidateIds.join(",");
  };

  console.log("Selected Candidate Ids: ", selectedCandidate);
  return (
    <div className="Actions_Wrapper tour-invited-actions">
      <div className="flex h-[40px] cursor-pointer overflow-hidden rounded-lg bg-grey [&>*:last-child]:border-r-0 [&>*]:grid [&>*]:w-[56px] [&>*]:min-w-[56px] [&>*]:place-items-center [&>*]:border-0 [&>*]:border-r [&>*]:border-r-[#E5E6E9] [&>*]:text-txtColor">
        {/* <MarkAsPreferredButton
          selectedCandidate={getRegisteredCandidate().split(",")}
          loading={shortListLoading}
          setLoading={setShortListLoading}
          deSelectAllCandidate={deSelectAllCandidate}
          page={SELECT_EXPORT_PAGES.INVITED}
          isSelectedAll={isSelectedAll}
          ignoreIds={
            isSelectedAll
              ? invitedCandidates
                .filter((ele) => !selectedIndex.includes(ele.index))
                .map((ele) => ele.candidate_id)
                .join(",")
              : ""
          }
          callback={handleReloadTable}
          type={"invited"}
        />

        <RemoveStatusButton
          selectedCandidate={getRegisteredCandidate().split(",")}
          loading={removeStatusLoading}
          setLoading={setRemoveStatusLoading}
          deSelectAllCandidate={deSelectAllCandidate}
          page={SELECT_EXPORT_PAGES.INVITED}
          isSelectedAll={isSelectedAll}
          ignoreIds={
            isSelectedAll
              ? invitedCandidates
                .filter((ele) => !selectedIndex.includes(ele.index))
                .map((ele) => ele.candidate_id)
                .join(",")
              : ""
          }
          callback={handleReloadTable}
          type={"invited"}
        />

        <MarkAsUnsuitableButton
          selectedCandidate={getRegisteredCandidate().split(",")}
          loading={unsuitableLoading}
          setLoading={setUnsuitableLoading}
          deSelectAllCandidate={deSelectAllCandidate}
          page={SELECT_EXPORT_PAGES.INVITED}
          isSelectedAll={isSelectedAll}
          ignoreIds={
            isSelectedAll
              ? invitedCandidates
                .filter((ele) => !selectedIndex.includes(ele.index))
                .map((ele) => ele.candidate_id)
                .join(",")
              : ""
          }
          callback={handleReloadTable}
          type={"invited"}
        />

        <Tooltip title={TOOLTIPTEXT.resendInvite}>
          <div
            className={`group ${ACTION_BTN_HOVER_CLR.lightBlue}`}
            onClick={() => {
              if (selectedCandidate.length > 0) {
                if (selectedCandidateIds !== "") {
                  dispatch(resendInvitedBankedCandidates({
                    selectedCandidateIds: selectedCandidateIds,
                    loading: inviteLoading,
                    setLoading: setInviteLoading
                  }))
                } else {
                  showCommonToast(toastMessageText.selectUnregisteredCandidate);
                }
              } else {
                showCommonToast(toastMessageText.noCandidateSelected, {
                  id: "no-candidate-selected",
                });
              }
            }}
          >
            <ActionIcons isLoading={inviteLoading} type={"invite"} />
          </div>
        </Tooltip>
        <AutoApproveCandidate
          selectedCandidate={selectedCandidate}
          selectedCandidateIds={getSelectedCandidateIds().split(",")}
          checkGetRegisteredCandidate={getRegisteredCandidate()}
          handleReloadTable={refreshTable}
          is_auto_booked_on_apply={0}
          is_remove_booked_on_apply={1}
        />
        {
          isPremiumAccount && user?.is_bank_client ? (
            selectedCandidateIds.length ? (
              <DeleteConfirmation
                selectedCount={selectedCandidate.length}
                onConfirm={handleDeleteConfirm}
                deleteLoading={deleteLoading}
                actionButtonClass={ACTION_BTN_HOVER_CLR.red}
                deleteDescriptionName="Candidate"
                extraDeleteText={""}
              />
            ) : (
              <Tooltip title={TOOLTIPTEXT.delete}>
                <button
                  className={`group ${ACTION_BTN_HOVER_CLR.red}`}
                  onClick={() => showCommonToast(toastMessageText?.deleteUnfillesCandidate, {
                    id: "no-user-selected",
                  })}
                >
                  <ActionIcons isLoading={deleteLoading} type={"delete"} />
                </button>
              </Tooltip>
            )
          ) : null
        } */}
        {selectedCandidate.length === 1 ? (
          <NoAccessButtonWrapper
            _checkPermission={["is_allow_to_edit_candidates"]}
          >
            <Tooltip title={TOOLTIPTEXT.edit}>
              <Link
                className={`group ${ACTION_BTN_HOVER_CLR.lightBlue}`}
                to={routingConstants.candidateEditRoute(
                  apiEncrypt(selectedCandidate[0]?.candidate_id),
                )}
              >
                <ActionIcons type={"edit"} />
              </Link>
            </Tooltip>
          </NoAccessButtonWrapper>
        ) : (
          <NoAccessButtonWrapper
            _checkPermission={["is_allow_to_edit_candidates"]}
          >
            <Tooltip title={TOOLTIPTEXT.edit}>
              <button
                className={`group ${ACTION_BTN_HOVER_CLR.lightBlue}`}
                onClick={() => {
                  if (selectedCandidate.length > 1) {
                    showCommonToast(
                      toastMessageText?.selectOneCandidateToEdit,
                      {
                        id: "no-user-selected",
                      },
                    );
                    return;
                  }
                  showCommonToast(toastMessageText?.noCandidateSelected, {
                    id: "no-user-selected",
                  });
                }}
              >
                <ActionIcons type={"edit"} />
              </button>
            </Tooltip>
          </NoAccessButtonWrapper>
        )}
      </div>
    </div>
  );
};
